<template>
    <departure-area-list-component :dept_area_list=deptAreaList :selected_area=selectedArea v-on:selectedArea="selectedArea = $event"/>
    <div class="cheapest_table" v-for="(deptArea, deptAreaKey) in deptAreaList">
        <table v-show="selectedArea == deptArea.id">
            <tbody>
                <tr>
                    <th></th>
                    <th class="row_head sun">朝発バス</th>
                    <th class="row_head moon">夜発バス</th>
                    <th class="row_head bullet">新幹線</th>
                </tr>

                <tr v-for="(value, key) in dateMomentList[deptArea.id]">
                    <th class="line_head">{{value.format("M/D")}}<br class="sponly">（{{value.format("ddd")}}）</th>
                    <template v-for="(transValue, transKey) in transportationItemList">
                        <one-week-best-price-component
                            :date=value
                            :trans=transValue
                            :dept_area=deptArea
                            :api_result_list=apiResultList
                            v-on:apiResultList="apiResultList[$event] = '読込中'"
                        />
                    </template>
                </tr>
            </tbody>
        </table>
    </div>

    <vue-element-loading :active="isLoading"/>
</template>

<script>
    import { ref, reactive, onMounted } from 'vue'
    import 'dayjs/locale/ja';
    export default ({
        props: {
            // 引数の受け問
            date_list : {type: String, require: true},
            dept_area_list : {type: String, require: true},
            trans : {type: String, require: true},
        },
        setup (props) {
            dayjs.locale('ja');
            
            const selectedArea = ref("1")
            const apiResultList = reactive({})
            const isLoading = ref(true)

            // セットアップ。初期実行
            let dateList = JSON.parse(props.date_list)
            let dateMomentList = {}

            let transportationItemList = JSON.parse(props.trans)
            transportationItemList.pop()

            let deptAreaList = JSON.parse(props.dept_area_list)

            Object.keys(deptAreaList).forEach(function (key) {
                let areaDateList = dateList[key]
                let tmpDateMomentList = []
                areaDateList.forEach(function(rawDate){
                    let targetDate = dayjs(rawDate)
                    tmpDateMomentList.push(targetDate)
                })
                
                dateMomentList[key] = tmpDateMomentList
            })

            // 完了時
            onMounted(() => {
                let urlList = []
                Object.keys(apiResultList).forEach(function (url) {
                    urlList.push(url)
                })

                if(urlList.length == 0) {
                    isLoading.value = false
                    return;
                }

                axios.post("/api/bestPrice/", {
                    urlList: urlList,
                })
                .then(function (response) {
                    Object.keys(response.data.bestPriceList).forEach(function (url) {
                        if(response.data.bestPriceList[url]) {
                            apiResultList[url] = response.data.bestPriceList[url].price.toLocaleString() + "円～"
                        } else {
                            apiResultList[url] = "-"
                        }
                    })

                    isLoading.value = false
                })
            })

            return {
                dateMomentList,
                transportationItemList,
                deptAreaList,
                selectedArea,
                apiResultList,
                isLoading,
            }
        },
    })
</script>